const deleteActiveNav = () => {
    const navList = document.getElementById('vehicleType');
    navList.classList.remove('active');
};
export default deleteActiveNav;